import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import state from './state'
import createLogger from 'vuex/dist/logger'
import paymenttransfer from './modules/paymenttransfer';
import cashRegister from './modules/cashRegister';

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

const store = new Vuex.Store({
  actions,
  getters,
  state,
  mutations,
  modules: { paymenttransfer, cashRegister },
  strict: debug,
  plugins: debug ? [createLogger()] : []
})

export default store


// WEBPACK FOOTER //
// ./src/store/index.js